import { render } from "./AddBanqueModal.vue?vue&type=template&id=7b706468&ts=true"
import script from "./AddBanqueModal.vue?vue&type=script&lang=ts"
export * from "./AddBanqueModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__